var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread-nav"},[_c('span',{staticClass:"bread-now"},[_vm._v("当前位置 ：")]),_c('ul',{staticClass:"bread-list"},[_c('li',[_vm._v(_vm._s(_vm.nowTab))])])])}
var staticRenderFns = []

export { render, staticRenderFns }